import React from "react";
import { CloudUploadOutlined } from '@ant-design/icons';
import 'antd/lib/icon/style/css';

const Placeholder = ({getInputProps, getRootProps, error, touched, label}) => (
  <div
    {...getRootProps()}
    className={`placeholder-preview ${error && touched ? "has-error" : ""}`}
  >
    <input {...getInputProps()} />
    <div className={'h-100'}>
      <p className={'m-0'}>Haz clic o arrastra para cargar un archivo</p>
      <CloudUploadOutlined style={{fontSize: '30px', marginTop: '10px'}} />
      <p>{label}</p>
    </div>
  </div>
);

export default Placeholder;
